import { TemplateSelector } from "./TemplateSelector";
export default TemplateSelector;
export * from "./TemplateSelector";
